import React from 'react';

export const SourcingIllustration = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none">
    <circle cx="46" cy="50.5" r="32" fill="white" />
    <path
      d="M61.515 51.1865C60.8756 49.3046 59.9051 47.5521 58.6492 46.0116C56.0709 42.7436 52.3141 40.6165 48.1852 40.087C43.9411 39.5784 39.6649 40.733 36.2535 43.3085C35.4032 43.9695 34.6645 44.7666 33.797 45.3936C32.9295 46.0205 32.3162 46.2538 31.5867 45.3527C30.4816 43.7598 29.0128 42.4533 27.3022 41.5411C25.3398 40.6146 23.175 40.1997 21.0091 40.3352C18.8433 40.4706 16.7469 41.1519 14.9153 42.3157C11.1632 44.714 6.91301 55.5798 7.57516 56.669C8.84775 58.7367 11.6961 58.3564 13.7612 58.3468L29.7349 58.17L46.144 58.0167L54.1309 57.9282L58.1244 57.9096C59.2849 57.9042 60.5652 57.9494 61.4484 57.0408C62.9008 55.5663 62.0861 52.8906 61.515 51.1865Z"
      fill="#F1F1F1"
    />
    <path
      d="M90.2404 77.2757C89.7986 75.9073 89.1133 74.6298 88.2175 73.5049C86.3825 71.1436 83.6942 69.5966 80.7307 69.1962C77.6759 68.7927 74.5837 69.5903 72.1052 71.421C71.493 71.8847 70.9495 72.4504 70.3201 72.8971C69.6907 73.3438 69.2478 73.5165 68.7327 72.8533C67.9426 71.6964 66.8879 70.7447 65.6562 70.0772C62.8337 68.6823 59.5247 69.1074 56.7238 70.5284C51.3605 73.2671 50.8885 80.0021 51.3615 80.7935C52.2218 82.2914 54.32 82.0598 55.8048 82.0614L67.2993 82.059L79.1181 82.0551L84.8695 82.0283L87.7025 82.0151C88.1213 82.0825 88.5492 82.0665 88.9617 81.9679C89.3743 81.8693 89.7632 81.6901 90.1063 81.4407C91.1683 80.4373 90.6046 78.5028 90.2404 77.2757Z"
      fill="#F1F1F1"
    />
    <path
      d="M35.4723 54.575L24.6836 55.425L28.4332 63.8466"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M31.5971 77.4343L30.9501 86.5922L88.9799 46.6868L63.0003 51.2451"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M65.2441 54.4426L17.126 66.7174L29.5724 72.2521"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M50.1838 39.8463C54.0405 36.304 53.5535 29.8705 53.5535 29.8705C53.5535 29.8705 73.4353 23.3594 72.9936 21.7109C72.4768 19.7821 53.0043 22.9414 53.0043 22.9414"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M58.9555 55.6682C58.9555 55.6682 58.8197 44.1492 52.1118 37.1829"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M53.1298 51.9285L53.6465 56.9229" stroke="#00005A" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M45.9288 59.344C45.9288 59.344 54.6329 50.121 47.6109 43.7954"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M19.3803 21.6854C27.0043 22.2772 34.6546 20.9412 41.6267 17.8005C41.6267 17.8005 45.0258 22.2434 47.7869 21.8658C51.628 21.3313 52.5133 17.4808 52.5133 17.4808C52.5133 17.4808 54.4059 17.0267 54.2217 16.0424C54.0375 15.0582 51.8823 10.6089 49.5544 9.66897C47.9497 9.02117 37.0017 19.5964 23.123 16.5304"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M41.7416 55.2891L43.8795 50.838C43.8795 50.838 39.4069 46.8065 38.9448 41.9831C38.3632 35.9549 42.1892 29.2315 42.1892 29.2315C36.3642 30.5715 27.2084 42.2302 25.5306 41.1779C23.8528 40.1256 31.2155 27.0833 41.91 22.8484"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M49.1249 14.793C49.1249 14.793 46.9445 12.6562 46.1989 15.7095"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M27.8771 12.4473C39.695 14.5813 44.9749 4.21731 47.2767 8.52131"
      stroke="#00005A"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <g opacity="0.8">
      <path
        opacity="0.8"
        d="M29.0284 76.9476L28.3724 75.3565C28.2395 75.0483 27.99 74.8051 27.6785 74.68C27.3669 74.555 27.0185 74.5582 26.7094 74.689L12.8769 80.4008C12.5618 80.533 12.3117 80.7842 12.1807 81.0997C12.1123 81.2601 12.0783 81.433 12.0808 81.6073C12.0834 81.7816 12.1225 81.9535 12.1957 82.1117L12.8517 83.7028C12.9613 83.9759 13.1627 84.2021 13.4213 84.3425C13.6799 84.4829 13.9794 84.5286 14.2681 84.4717C14.3561 84.4612 14.4421 84.4382 14.5236 84.4033L28.3516 78.675C28.508 78.6125 28.6503 78.5193 28.7702 78.401C28.89 78.2827 28.985 78.1416 29.0495 77.986C29.114 77.8304 29.1467 77.6635 29.1457 77.4951C29.1448 77.3267 29.1102 77.1602 29.0439 77.0053L29.0284 76.9476Z"
        fill="url(#paint0_linear_54704_27780)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_54704_27780"
        x1="11.9687"
        y1="81.1309"
        x2="29.2295"
        y2="77.8944"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9F8A" />
        <stop offset="0.05" stopColor="#FF9793" />
        <stop offset="0.11" stopColor="#FF8AA4" />
        <stop offset="0.15" stopColor="#FF80B1" />
        <stop offset="0.24" stopColor="#FF66D2" />
        <stop offset="0.33" stopColor="#FF44FF" />
        <stop offset="0.66" stopColor="#4900FF" />
        <stop offset="1" stopColor="#00005A" />
      </linearGradient>
    </defs>
  </svg>
);
